import { withTranslation } from "react-i18next"
import { Image, Divider, Select, Button, Spin, Modal, } from "antd";
import { 
  useState, 
} from "react";
import styled from "styled-components";

// Local
import Text from "components/Text";
import AppDivider from 'components/Divider';
import React from "react";
import { post } from "library/endpoints";

import * as Styled from '../../../../styled';
import { connect } from "react-redux";

const StyledContainer = styled.div`
  button.ant-btn-primary {
    background: ${ props => props.theme.buttonColor} !important;
  }
`;


/**
 * SelectPlacements
 * @param {*} props 
 * @returns 
 */
const SelectPlacements = (props) => {

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleOnSelectIris = (pos) => (iris) => {
    const positions = [...props.customizedEffect.positions].map((position) => {
      if (position.layername === pos.layername) {
        position.iris = iris;
      }
      return position;
    });
    const selectedEffect = {...props.customizedEffect, position: positions};
    props.setCustomizedEffect(selectedEffect)
  }

  const handleOnSubmit = async () => {
    setLoading(true);
    try {
      // Effect processing
      const data = {
        effectId: props.customizedEffect._id,
        selectedIris: props.customizedEffect.position.map((si) => si.iris),
        position: props.customizedEffect.positions
      }
      await post(`frontend/effect-processing/generate-layers`, data);
      setSuccess(true);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }


  if (!props.customizedEffect) {
    return null;
  }

  return (
    <Styled.MobileWrapper>
      <StyledContainer
        theme={props.ui.theme}
      >
        <Image 
          src={props.getEffectUrl(props.selectedEffect)} 
          width={200}
          alt={props.customizedEffect.name}
          style={{ boxShadow: '0 0 10px grey'}}
        />

        
        <Text align="center" size={14} style={{ marginTop: 10 }}>Choisissez le ou les iris à intégrer</Text>

        <Divider />
        {
          loading ? (
            <Modal
              footer={null}
              visible={loading}
              closable={success ? true : false}
              maskClosable={success ? true : false}
              onOk={() => props.resetEnv()}
              onCancel={() => props.resetEnv()}
            >
              <div style={{ textAlign: 'center'}}>
                {
                  success ? (
                    <Text align="center" size={14} style={{ marginTop: 20 }}>La création de votre montage est en cours, vous recevrez une notification par mail dans quelques instants, dès que celui ci sera disponible. </Text>
                  ) : (
                    <>
                      <Spin />
                      <Text align="center" size={14} style={{ marginTop: 20 }}>Veuillez patienter quelques instants</Text>
                    </>
                  )
                }
              </div>
            </Modal>
          ) : (
            <>
              {
                props.customizedEffect.positions.map((pos) => (
                  <React.Fragment key={`effect-position-${pos._id}`}>
                    <Text style={{ marginBottom: 10 }} size={14}>{pos.usualname}</Text>
                    <Select 
                      style={{ width: '100%' }}
                      onChange={(val) => handleOnSelectIris(pos)(val)}  
                    >
                      {
                        props.userIris.map((iris) => (
                          <Select.Option value={iris._id} key={`iris-effect-select-position-${iris._id}`}>{iris.name}</Select.Option>
                        ))
                      }
                    </Select>
                    <AppDivider height={20} />          
                  </React.Fragment>
                ))
              }
              <Button type="primary" onClick={handleOnSubmit} style={{ width: '100%'}}>Créer mon montage</Button>
            </>
          )
        }
      </StyledContainer>
    </Styled.MobileWrapper>
  )
}

const stateToProps = state => ({
  ui: state.ui
})

export default connect(stateToProps)(withTranslation()(SelectPlacements));